import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './global-card-styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';
import { Provider } from 'react-redux';
import store from './apis/store/store';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from './themes/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename='/'>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);
